export const PoolUomPolicy = ({

    TEU: "TEU",
    ITEM: "ITEM"
})